// extracted by mini-css-extract-plugin
export default {"root":"Sidebar_root__8VyiZ","sidebarHeader":"Sidebar_sidebarHeader__0mlCx","sidebarTitle":"Sidebar_sidebarTitle__r62Mk","chatList":"Sidebar_chatList__Da1fD"};